import { apiRoutes } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  show() {
    const url = apiRoutes.userPath(1);
    return FetchHelpers.get(url);
  },

  create(attrs) {
    const url = apiRoutes.userPath(1);
    return FetchHelpers.post(url, attrs);
  },

  update(attrs) {
    const url = apiRoutes.userPath(1);
    return FetchHelpers.patch(url, attrs);
  },
};
